import type { IConversation } from 'src/api/landlord-messages-api';
import type { ILead } from 'src/services/api/leads/types';
import { insertLeadByInsertedAt } from 'src/services/api/leads/lead-ordering';
import type { ISearchResponse } from 'src/services/api/messages/use-conversations-search';

export const reconcileLeadCollection = (
    cachedLeads: ILead[] | undefined,
    freshLead: ILead,
): ILead[] => {
    const leads = cachedLeads ?? [];
    const existingIndex = leads.findIndex(({ uuid }) => uuid === freshLead.uuid);

    if (existingIndex >= 0) {
        return leads.map((lead, index) => index === existingIndex ? freshLead : lead);
    }

    return insertLeadByInsertedAt(leads, freshLead);
};

export const patchConversationProperty = (
    conversations: IConversation[] | undefined,
    freshLead: ILead,
): IConversation[] | undefined => conversations?.map((conversation) => (
    conversation.lead_uuid === freshLead.uuid ?
        { ...conversation, property_id: freshLead.property_id } :
        conversation
));

export const removeLeadFromCollection = (
    leads: ILead[] | undefined,
    leadUuid: string,
): ILead[] | undefined => leads?.filter((lead) => lead.uuid !== leadUuid);

export const removeLeadFromConversations = (
    conversations: IConversation[],
    leadUuid: string,
): IConversation[] => conversations.filter(
    (conversation) => conversation.lead_uuid !== leadUuid,
);

export const removeLeadFromConversationSearch = (
    search: ISearchResponse,
    leadUuid: string,
): ISearchResponse => ({
    ...search,
    results: search.results.filter((result) => (
        result.match.lead_uuid !== leadUuid && result.lead.uuid !== leadUuid
    )),
});
